import { type Registry as Services, service } from '@ember/service';
import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { ComparisonSet } from 'frontend-utils/utils/constants/benchmark-insight';
import type { BeniBreakdownPeriod } from 'lumen/models';

export const BREAKDOWN_PERIOD_TYPES = {
  CURRENT: 'current',
  REFERENCE: 'reference',
} as const;
export type BreakdownPeriodType =
  (typeof BREAKDOWN_PERIOD_TYPES)[keyof typeof BREAKDOWN_PERIOD_TYPES];

export default class BeniBreakdown extends Model {
  [Type] = 'benchmark-insight/breakdown' as const;

  // Data for the current period
  @belongsTo('benchmark-insight/breakdown-period', {
    async: false,
    inverse: null,
  })
  declare current: BeniBreakdownPeriod;

  // Data for the reference period
  @belongsTo('benchmark-insight/breakdown-period', {
    async: false,
    inverse: null,
  })
  declare ref: BeniBreakdownPeriod;

  @attr('string') declare comparisonSetType: ComparisonSet;
  // Date string (e.g. '2023-02-24') for 'day' segmentations, or segment type (e.g. 'transient') for segment breakdowns, or LOS (e.g. 3) for LOS
  @attr('string') declare label: string;
  @attr('string') declare refDay: string;

  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get date() {
    return this.hotelAndMarketService.toLocalTime(this.label);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get los() {
    return parseInt(this.label, 10);
  }

  // Date string for 'day' segmentations, null for 'segment', 'los', etc
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getBreakdownPeriodByBreakdownPeriodType(breakdownType: BreakdownPeriodType) {
    const BREAKDOWN_PERIOD_TYPE_MAPPING = {
      [BREAKDOWN_PERIOD_TYPES.CURRENT]: this.current,
      [BREAKDOWN_PERIOD_TYPES.REFERENCE]: this.ref,
    };

    return BREAKDOWN_PERIOD_TYPE_MAPPING[breakdownType];
  }
}
